import React from 'react'
import { createRoot } from 'react-dom/client'
import App from 'src/app'
import { setJwtAuthHeaders } from './utils/api'
import { KEYCLOAK } from './utils/auth'

function InitAppContainer() {
  const container = document.getElementById('root')
  const root = createRoot(container)
  root.render(<App />)
}

if (!!process.env.REACT_APP_MOCK_MODE) {
  InitAppContainer()
} else {
  KEYCLOAK.init({ onLoad: 'login-required' })
    .then((auth) => {
      if (!auth) {
        window.location.reload()
      }

      sessionStorage.setItem('kc-access-token', KEYCLOAK.token)
      setJwtAuthHeaders(KEYCLOAK.token)
      InitAppContainer()
    })
    .catch(() => {
      console.error('Authenticated Failed')
    })
}
